const _phablet = {"min":"600px"}
const _tablet = {"min":"1020px"}
const _laptop = {"min":"1272px"}
const _desktop = {"min":"1512px"}
const _extdesktop = {"min":"1920px"}
const config = { "phablet": _phablet, "tablet": _tablet, "laptop": _laptop, "desktop": _desktop, "extdesktop": _extdesktop,  }
export { config as default, _phablet, _tablet, _laptop, _desktop, _extdesktop }